export default "__VITE_ASSET__DZB2DpIr__"